
// @ts-nocheck


export const localeCodes =  [
  "fr",
  "en",
  "lu"
]

export const localeLoaders = {
  "fr": [{ key: "../i18n/locales/fr.json", load: () => import("../i18n/locales/fr.json" /* webpackChunkName: "locale__vercel_path0_i18n_locales_fr_json" */), cache: true }],
  "en": [{ key: "../i18n/locales/en.json", load: () => import("../i18n/locales/en.json" /* webpackChunkName: "locale__vercel_path0_i18n_locales_en_json" */), cache: true }],
  "lu": [{ key: "../i18n/locales/lu.json", load: () => import("../i18n/locales/lu.json" /* webpackChunkName: "locale__vercel_path0_i18n_locales_lu_json" */), cache: true }]
}

export const vueI18nConfigs = [
  
]

export const nuxtI18nOptions = {
  "restructureDir": "i18n",
  "experimental": {
    "localeDetector": "",
    "switchLocalePathLinkSSR": false,
    "autoImportTranslationFunctions": false,
    "typedPages": true,
    "typedOptionsAndMessages": false,
    "generatedLocaleFilePathFormat": "absolute"
  },
  "bundle": {
    "compositionOnly": true,
    "runtimeOnly": false,
    "fullInstall": true,
    "dropMessageCompiler": false,
    "optimizeTranslationDirective": true
  },
  "compilation": {
    "jit": true,
    "strictMessage": true,
    "escapeHtml": false
  },
  "customBlocks": {
    "defaultSFCLang": "json",
    "globalSFCScope": false
  },
  "vueI18n": "",
  "locales": [
    {
      "code": "fr",
      "language": "fr-FR",
      "name": "Français",
      "files": [
        "/vercel/path0/i18n/locales/fr.json"
      ]
    },
    {
      "code": "en",
      "language": "en-GB",
      "name": "English",
      "files": [
        "/vercel/path0/i18n/locales/en.json"
      ]
    },
    {
      "code": "lu",
      "language": "lu-LU",
      "name": "Letzebuergesch",
      "files": [
        "/vercel/path0/i18n/locales/lu.json"
      ]
    }
  ],
  "defaultLocale": "fr",
  "defaultDirection": "ltr",
  "routesNameSeparator": "___",
  "trailingSlash": false,
  "defaultLocaleRouteNameSuffix": "default",
  "strategy": "prefix_except_default",
  "lazy": true,
  "langDir": "locales/",
  "detectBrowserLanguage": {
    "alwaysRedirect": false,
    "cookieCrossOrigin": false,
    "cookieDomain": null,
    "cookieKey": "fg_lang_redirected",
    "cookieSecure": false,
    "fallbackLocale": "fr",
    "redirectOn": "root",
    "useCookie": true
  },
  "differentDomains": false,
  "baseUrl": "https://preview.novarh.lu",
  "customRoutes": "config",
  "pages": {
    "index": {
      "en": "/",
      "lu": "/",
      "fr": "/"
    },
    "articles": {
      "en": "/newsletter",
      "lu": "/newsletter",
      "fr": "/newsletter"
    },
    "particle/[slug]": {
      "en": "/article/[slug]",
      "lu": "/artikel/[slug]",
      "fr": "/article/[slug]"
    },
    "history": {
      "en": "/history",
      "lu": "/geschicht",
      "fr": "/a-propos"
    },
    "jobs": {
      "en": "/jobs",
      "lu": "/jobs",
      "fr": "/emplois"
    },
    "services": {
      "en": "/services",
      "lu": "/déngschter",
      "fr": "/services"
    },
    "team": {
      "en": "/team",
      "lu": "/team",
      "fr": "/equipe"
    },
    "platform": {
      "en": "/platform",
      "lu": "/plattform",
      "fr": "/plateforme"
    },
    "testimonials": {
      "en": "/testimonials",
      "lu": "/testimonials",
      "fr": "/temoignages"
    },
    "contact": {
      "en": "/contact",
      "lu": "/contact",
      "fr": "/contact"
    }
  },
  "skipSettingLocaleOnNavigate": false,
  "types": "composition",
  "debug": false,
  "parallelPlugin": false,
  "multiDomainLocales": false,
  "i18nModules": []
}

export const normalizedLocales = [
  {
    "code": "fr",
    "language": "fr-FR",
    "name": "Français",
    "files": [
      {
        "path": "/vercel/path0/i18n/locales/fr.json"
      }
    ]
  },
  {
    "code": "en",
    "language": "en-GB",
    "name": "English",
    "files": [
      {
        "path": "/vercel/path0/i18n/locales/en.json"
      }
    ]
  },
  {
    "code": "lu",
    "language": "lu-LU",
    "name": "Letzebuergesch",
    "files": [
      {
        "path": "/vercel/path0/i18n/locales/lu.json"
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false
export const hasPages = true

export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18nInternal"
export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
